(function () {
  var TARGET_HASH = '#order-now';
  var TARGET_SELECTOR = '#shopify-section-template--20291722084542__lana_product_homepage_cfYBdj > div > div.fp-right-column > div.fp-tabs-container > h3';

  function getHeader() {
    return document.querySelector('.section-header');
  }

  function headerHeight(header) {
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().height));
  }

  function forceHeaderVisible(header) {
    if (!header) return null;
    var prev = { top: header.style.top, transition: header.style.transition };

    header.classList.add('shopify-section-header-sticky');
    header.classList.remove('shopify-section-header-hidden');

    header.style.transition = 'none';
    header.style.top = '0px';

    return prev;
  }

  function restoreHeader(header, prev) {
    if (!header || !prev) return;
    header.style.top = prev.top;
    header.style.transition = prev.transition;
  }

  function resolveTarget() {
    return (
      document.querySelector(TARGET_SELECTOR) ||
      document.getElementById('order-now') ||
      document.querySelector('#shopify-section-template--20291722084542__lana_product_homepage_cfYBdj .fp-tabs-container > h3')
    );
  }

  function instantJumpTo(el) {
    if (!el) return;

    var header = getHeader();
    var prevHeader = forceHeaderVisible(header);

    var root = document.documentElement;
    var prevSB = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';

    var y = el.getBoundingClientRect().top + window.pageYOffset - headerHeight(header);
    y = Math.max(0, Math.round(y));

    window.scrollTo(0, y);

    setTimeout(function () { window.scrollTo(0, y); }, 60);
    setTimeout(function () {
      var y2 = el.getBoundingClientRect().top + window.pageYOffset - headerHeight(header);
      window.scrollTo(0, Math.max(0, Math.round(y2)));
      root.style.scrollBehavior = prevSB;
      restoreHeader(header, prevHeader);
    }, 220);
  }

  function isTargetLink(a) {
    if (!a) return false;

    // Only handle the real anchor link: href="#order-now"
    var href = (a.getAttribute('href') || '').trim();
    return href === TARGET_HASH;
  }

  function go() {
    var el = resolveTarget();
    if (!el) return;
    instantJumpTo(el);
    try { history.pushState(null, '', TARGET_HASH); } catch (e) {}
  }

  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!isTargetLink(a)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    go();
  }, true);

  window.addEventListener('hashchange', function () {
    if (location.hash === TARGET_HASH) go();
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    if (location.hash === TARGET_HASH) go();
  });
})();
